/**
 * @fileoverview Generic dashboard stats grid component
 */

import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { DashboardStatsCard } from "./DashboardStatsCard";

/**
 * DashboardStatsGrid - A grid of stats cards
 * @param {Array} stats - Array of stat configurations
 */
export const DashboardStatsGrid = ({ stats = [] }) => {
    if (!stats || stats.length === 0) return null;

    return (
        <Grid container spacing={2}>
            {stats.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={stat.key || index}>
                    <DashboardStatsCard
                        title={stat.title}
                        value={stat.value}
                        icon={stat.icon}
                        color={stat.color}
                        subtitle={stat.subtitle}
                        onClick={stat.onClick}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

DashboardStatsGrid.propTypes = {
    stats: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        title: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        icon: PropTypes.elementType,
        color: PropTypes.string,
        subtitle: PropTypes.string,
        onClick: PropTypes.func
    }))
};
